import React from 'react';
import {BranchStatus} from './BranchStatus';
import MenuPage from '../../pages/MenuPage';
import "./Status.css";

export const Status = (props) => {
    return (
        <MenuPage title="Status"  onBackClick={()=>{props.history.goBack()}}>
            <div className="dark">
                <div className="container">
                    <div className="StatusHeader dark">
                        
                    </div>
                </div>
            </div>
            <div className="container">
            <div className="StatusBody">
            {
                props.statuses.map((branch, i) => (
                    <BranchStatus key={i} branchStatus={branch}/>
                ))
            }
            </div>
            </div>
        </MenuPage>
    );
};


export default Status;


// WEBPACK FOOTER //
// ./src/components/deviceStatus/Status.js